import React from 'react';
import { Row, Col, Popconfirm, Tooltip, Modal } from 'antd';
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';
import CustomAvatar from '../../CustomComponents/CustomAvatar';
import { ActionButton } from '../../CustomComponents/Table/styledComponents';
import ReInviteIcon from '../../../Assets/Icons/ReInviteIcon';
import { PopoverGlobalStyle } from '../JobList/styledComponents';
import EnableUserIcon from '../../../Assets/Icons/EnableUserIcon';

const multiSelectFilter = (row, columnId, filterValue) => {
  if (!filterValue || filterValue.length === 0) return true;
  const val = row.getValue(columnId);
  const strVal = val != null ? String(val) : 'N/A';
  return filterValue.includes(strVal);
};

export const createBillerGroupColumns = (
  setSelectedItem,
  setAddDrawerVisible,
  deactivateGroup,
  notClinicAdmin
) => [
  {
    id: 'groupName',
    header: 'Group Name',
    accessorKey: 'groupName',
    enableSorting: true,
    sortingFn: 'text',
    filterFn: multiSelectFilter,
    cell: ({ getValue }) => {
      const val = getValue();
      return (
        <span title={val}>
          {val?.length > 40 ? val.slice(0, 40) + '...' : val}
        </span>
      );
    }
  },
  {
    id: 'billers',
    header: 'Members',
    accessorKey: 'billers',
    enableSorting: false,
    enableColumnFilter: false,
    cell: ({ getValue }) => {
      const billers = getValue() || [];
      if (billers.length === 0) {
        return <span style={{ color: '#999' }}>No members</span>;
      }
      return (
        <div>
          {billers.map(b => (
            <div key={b.id}>{b.fullName}</div>
          ))}
        </div>
      );
    }
  },
  {
    id: 'status',
    header: 'Status',
    accessorKey: 'active',
    enableSorting: false,
    enableColumnFilter: false,
    cell: ({ getValue }) => (
      <span style={{ color: getValue() ? '#52c41a' : '#aaa' }}>
        {getValue() ? 'Active' : 'Inactive'}
      </span>
    )
  },
  {
    id: 'actions',
    header: 'Action',
    size: 100,
    enableSorting: false,
    enableColumnFilter: false,
    cell: ({ row }) => {
      const group = row.original;

      // Deactivate action commented out — deactivate endpoint not available yet
      // const handleDeactivate = () => {
      //   const doctors = group.assignedDoctors || [];
      //   const content =
      //     doctors.length > 0 ? (
      //       <div>
      //         <p>This group is currently assigned to the following doctors:</p>
      //         <ul style={{ paddingLeft: 20, margin: '8px 0' }}>
      //           {doctors.map(d => (
      //             <li key={d.id}>{d.name}</li>
      //           ))}
      //         </ul>
      //         <p>Are you sure you want to deactivate it?</p>
      //       </div>
      //     ) : (
      //       'Are you sure you want to deactivate this group?'
      //     );
      //   Modal.confirm({
      //     title: 'Deactivate Biller Group',
      //     content,
      //     onOk: () => deactivateGroup(group.id),
      //     okText: 'Deactivate',
      //     cancelText: 'Cancel',
      //     okButtonProps: { danger: true }
      //   });
      // };

      return (
        <Row gutter={8}>
          <Col>
            <Tooltip title='Edit group'>
              <ActionButton
                onClick={() => {
                  setSelectedItem(group);
                  setAddDrawerVisible(true);
                }}
                icon={<EditOutlined />}
              />
            </Tooltip>
          </Col>
          {/* Deactivate button commented out — deactivate endpoint not available yet */}
          {/* {group.active && !notClinicAdmin && (
            <Col>
              <Tooltip title='Deactivate group'>
                <ActionButton
                  onClick={handleDeactivate}
                  icon={<DeleteOutlined />}
                />
              </Tooltip>
            </Col>
          )} */}
        </Row>
      );
    }
  }
];

export const createBillerColumns = (
  setSelectedItem,
  setAddDrawerVisible,
  disableUser,
  reInvite,
  notClinicAdmin
) => [
  {
    id: 'avatar',
    header: ' ',
    accessorKey: 'signedUrl',
    size: 35,
    enableSorting: false,
    enableColumnFilter: false,
    cell: ({ row }) => (
      <CustomAvatar url={row.original.signedUrl} size={35} />
    )
  },
  {
    id: 'fullName',
    header: 'Name',
    accessorKey: 'fullName',
    enableSorting: true,
    sortingFn: 'text',
    filterFn: multiSelectFilter,
    cell: ({ getValue }) => {
      const val = getValue();
      return (
        <span title={val}>
          {val?.length > 30 ? val.slice(0, 30) + '...' : val}
        </span>
      );
    }
  },
  {
    id: 'email',
    header: 'Email',
    accessorKey: 'email',
    enableSorting: true,
    filterFn: multiSelectFilter
  },
  {
    id: 'phoneNumber',
    header: 'Phone Number',
    accessorKey: 'phoneNumber',
    enableSorting: false,
    enableColumnFilter: false,
    cell: ({ getValue }) => {
      const value = getValue();
      return value && (value.countryCode === null || value.number === null)
        ? ''
        : value && <div>+{value.countryCode + '-' + value.number}</div>;
    }
  },
  {
    id: 'actions',
    header: 'Action',
    size: 180,
    enableSorting: false,
    enableColumnFilter: false,
    cell: ({ row }) => {
      const user = row.original;
      return (
        <Row gutter={12}>
          <Col>
            <Tooltip title='Edit user'>
              <ActionButton
                onClick={() => {
                  setSelectedItem(user);
                  setAddDrawerVisible(true);
                }}
                icon={<EditOutlined />}
                disabled={!user.isEnabled}
              />
            </Tooltip>
          </Col>
          <Col>
            <Popconfirm
              title={
                <>
                  {user.isEnabled ? 'Disable' : 'Enable'} {user.fullName} ?
                </>
              }
              onConfirm={() => disableUser(user.id)}
              okText='Yes'
              cancelText='No'
              overlayClassName='popover-delete-confirm'
              disabled={notClinicAdmin}
            >
              <PopoverGlobalStyle />
              <Tooltip title={user.isEnabled ? 'Disable user' : 'Enable user'}>
                <ActionButton
                  disabled={notClinicAdmin}
                  icon={
                    user.isEnabled ? (
                      <DeleteOutlined />
                    ) : (
                      <EnableUserIcon disabled={notClinicAdmin} />
                    )
                  }
                />
              </Tooltip>
            </Popconfirm>
          </Col>
          <Col>
            <Popconfirm
              title='Are you sure you want to re-invite?'
              onConfirm={() => reInvite(user.id)}
              okText='Yes'
              cancelText='No'
              overlayClassName='popover-delete-confirm'
            >
              <Tooltip title='Reinvite user'>
                <ActionButton
                  icon={<ReInviteIcon disabled={!user.isEnabled} />}
                  disabled={!user.isEnabled}
                />
              </Tooltip>
            </Popconfirm>
          </Col>
        </Row>
      );
    }
  },
  {
    id: 'status',
    header: 'Status',
    accessorKey: 'status',
    size: 100,
    enableSorting: false,
    enableColumnFilter: false,
    cell: ({ getValue }) => <span>{getValue() || '—'}</span>
  }
];
